import React, { useState, useEffect } from "react";
import classes from "../style/Style.module.css";
import "../style/Infoscreens.scss";
import DexterCall from "../Images/UpdatedDexter-call.svg";
import {
  ROUTE_EMAIL,
  ROUTE_ACCOUNT_TYPE,
  Address_Verification,
  ROUTE_NOMINEE_DETAILS,
  Gender_Dob_Verification,
  Pincode_Verification,
  ROUTE_OCCUPATION,
  ROUTE_PLACEOF_BIRTH,
  ROUTE_CHECKBOXES, ROUTE_NRI_Address,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
  ROUTE_NOMINEE_SENDOTP,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_DXTER_SCANNING,
} from "../Routes";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../libs/axiosConfig";
import { useSelector } from "react-redux";
import { selectPanNumber } from "../Store/panNumberSlice";
import { ToastContainer } from "react-toastify";
import Toast from "../Components/ToastMsg/Toast";
import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../Images/NewDexterLogo.svg";
import LogoutModal from "../Components/LogoutModal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { selectTransactionNumber } from "../Store/TransactionNoSlice";
import { selectPhoneNumber } from "../Store/MobileSlice";

const NomineeVerification = () => {
  const [verifyButtonClicked, setVerifyButtonClicked] = useState(false);
  const Navigate = useNavigate();
  const location = useLocation();
  const [seconds, setSeconds] = useState("");
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const panNumber = useSelector(selectPanNumber);
  const [verificationError, setVerificationError] = useState(false);
  const [timerId, setTimerId] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [guardianVerification, setGuardianVerification] = useState("");
  const refreshToken = useSelector(selectRefreshToken);
  const [nomineephoneNumber, setNomineephoneNumber] = useState(
    location.state?.nomineephoneNumber || ""
  );
  const [showModal, setShowModal] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);

  const [isLoading, setIsLoading] = useState(false);
  const transactionNumber = useSelector(selectTransactionNumber);
  const phoneNumber = useSelector(selectPhoneNumber);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);;

  useEffect(() => {
    console.log("Location State:", location.state);
    const { nomineephoneNumber } = location.state || {};
    console.log("Nominee Phone Number:", nomineephoneNumber);
    setNomineephoneNumber(nomineephoneNumber);
  }, [location.state]);

  const handleguardianVerificationChange = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    setGuardianVerification(input);
  };

  const handleguardianVerificationClear = () => {
    setGuardianVerification("");
  };

  const HandleSubmit = async () => {
    if (guardianVerification.length !== 6) {
      setVerificationError(true);
      Toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    try {

      setApiCallsInProgress(apiCallsInProgress + 1);
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      const dexterrverifyOtp = "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

      const token = storedToken;
      console.log(nomineephoneNumber)
      const requestData = {
        OtpVerification: {
          mobileNumber: nomineephoneNumber,
          pan: panNumber,
          // pan : "BORPT8894P",
          service: "nominee",
          job: "verifyOtp",
          otp: guardianVerification,
        },
      };
      console.log(nomineephoneNumber)
      const dexterrverifyOtpresponse = await axios.post(dexterrverifyOtp, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // const dexterrverifyOtp =
      //   "https://partnerapp.ambrela.money/api/nominee-verification";
      // const dexterrverifyOtprequest = {
      //   job: "verifyOtp",
      //   otp: guardianVerification,
      // };
      // const dexterrverifyOtpresponse = await axios.post(
      //   dexterrverifyOtp,
      //   dexterrverifyOtprequest,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       // RefreshToken: refreshToken
      //     },
      //   }
      // );

      if (dexterrverifyOtpresponse.data.statusCode === 200) {
        setApiCallsInProgress(apiCallsInProgress + 1);
        const thirdapi =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const thirdRequestBody = {
          CustomerKycDetails: {
            request_type: "get",
            mobileNumber: nomineephoneNumber,
            pan: panNumber,
            // pan : "BORPT8894P",
          },
        };

        const thirdResponse = await axios.post(thirdapi, thirdRequestBody, {
          headers,
        });

        console.log("Response from third party API:", thirdResponse.data);

        // const customerKycApiResponse = await axios.get(
        //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",
        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken,
        //     },
        //   }
        // );



        if (
          thirdResponse.data.statusCode === 200 &&
          thirdResponse.data.status === true

        ) {
          setApiCallsInProgress(apiCallsInProgress + 1);

          if (
            thirdResponse.data.body.bankAccountNumber === "" ||

            thirdResponse.data.body.bankIfscCode === "" ||

            thirdResponse.data.body.bankAccountType === "" ||

            thirdResponse.data.body.bankName === "" ||

            thirdResponse.data.body.bankBranchName === "" ||

            thirdResponse.data.body.bankBranchAddress === "" ||

            thirdResponse.data.body.bankCodeNSE === "" ||

            thirdResponse.data.body.bankCodeBillDesk === "" ||

            thirdResponse.data.body.bankAccountHolderName === ""
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            (thirdResponse.data.body.bankAccountNumber !== "" ||

              thirdResponse.data.body.bankIfscCode !== "" ||

              thirdResponse.data.body.bankAccountType !== "" ||

              thirdResponse.data.body.bankName !== "" ||

              thirdResponse.data.body.bankBranchName !== "" ||

              thirdResponse.data.body.bankBranchAddress !== "" ||

              thirdResponse.data.body.bankCodeNSE !== "" ||

              thirdResponse.data.body.bankCodeBillDesk !== "" ||

              thirdResponse.data.body.bankAccountHolderName !== ""
            ) &&
            (thirdResponse.data.body.bankVerified.account_exists !== "True" ||
              thirdResponse.data.body.bankVerified.message !== "success")
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            thirdResponse.data.body.panDetails.gender === "" ||

            thirdResponse.data.body.panDetails.title === "" ||

            thirdResponse.data.body.panDetails.dob === ""

          ) {
            Navigate(Gender_Dob_Verification);
          } else if (
            thirdResponse.data.body.panDetails.addr1 === "" ||

            thirdResponse.data.body.panDetails.addr2 === "" ||

            thirdResponse.data.body.panDetails.city === "" ||

            thirdResponse.data.body.panDetails.state === "" ||

            thirdResponse.data.body.panDetails.pincode === "" ||

            thirdResponse.data.body.panDetails.country === "" ||

            thirdResponse.data.body.panDetails.fullAddress === ""

          ) {
            Navigate(Address_Verification);
          } else if (
            thirdResponse.data.body.nseIncomeCode === "" ||

            thirdResponse.data.body.nseIncomeCodeDescription === "" ||

            thirdResponse.data.body.nseOccupationCode === "" ||

            thirdResponse.data.body.nseOccupationCodeDescription === ""
          ) {
            Navigate(ROUTE_OCCUPATION);
          } else if (
            thirdResponse.data.body.placeOfBirth === "" ||

            thirdResponse.data.body.nseCountryCodeOfBirth === "" ||

            thirdResponse.data.body.nseCountryOfBirth === ""
          ) {
            Navigate(ROUTE_PLACEOF_BIRTH);
          } else if (
            thirdResponse.data.body.politicallyExposedPerson === "" ||

            thirdResponse.data.body.relatedToPoliticallyExposedPerson === ""

          ) {
            Navigate(ROUTE_CHECKBOXES);
          } else if (
            ((thirdResponse.data.body.nomineeDob === "") &&
              thirdResponse.data.body.nomineeName === "")
          ) {

            Navigate(ROUTE_NOMINEE_DETAILS);
          }
          // else if (
          //   ((thirdResponse.data.body.nomineeName !== "" ) &&
          //     thirdResponse.data.body.nomineeDob === "") 
          // ) {

          //   Navigate(ROUTE_NOMINEE_DETAILS);
          // } 
          else if (
            (thirdResponse.data.body.nomineeName !== "" &&
              thirdResponse.data.body.nomineeType !== "" &&
              thirdResponse.data.body.nomineeRelationShip !== "" &&
              thirdResponse.data.body.nomineeDob !== ""
            ) &&
            (thirdResponse.data.body.nomineeVerified === "N")
          ) {
            console.log("first");
            Navigate(ROUTE_NOMINEE_SENDOTP);
          }

          else {
            setApiCallsInProgress(apiCallsInProgress + 1);
            const requestBody = {
              dexterrCustomerBasicQuestions: {
                mobile_no: phoneNumber,
                request_type: "get",
                country_code: "+91",
              }
            };
            const headers = {
              Authorization: `Bearer ${storedToken}`,
              // RefreshToken: refreshToken
            };

            const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
              headers: headers
            });
            if (secondApiResponse.data.data.resident !== "Resident Indian") {
              Navigate(ROUTE_NRI_Address)
              console.log("redirecting")
            }


            else {
              Navigate(ROUTE_DXTER_SCANNING);

            }
          }
        } else {
          Toast.error(
            thirdResponse.data.message + " " + thirdResponse.data.errorMessage
          );
          setApiCallsInProgress(apiCallsInProgress - 1);

        }
      } else {
        // Toast.error(response.data.message + " " + response.data.errorMessage);
        setApiCallsInProgress(apiCallsInProgress - 1);

      }
    } catch (error) {
      setApiCallsInProgress(apiCallsInProgress - 1);

      console.error("Error occurred:", error);
      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
        "Error"
      );
    }
  };

  const handleResendButtonClick = async () => {
    setApiCallsInProgress(apiCallsInProgress + 1);
    setSeconds(59);
    if (timerId) {
      clearInterval(timerId);
    }
    const id = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          clearInterval(id);
          return "";
        }
        return prevSeconds - 1;
      });
    }, 1000);
    setTimerId(id);

    try {
      const dexterrsendOtp =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

      const token = storedToken;

      const requestData = {
        OtpVerification: {
          mobileNumber: nomineephoneNumber,
          pan: panNumber,
          service: "nominee",
          job: "sendOtp",
        },
      };
      console.log(nomineephoneNumber)
      const dexterrsendOtpresponse = await axios.post(dexterrsendOtp, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
          // RefreshToken: refreshToken

        },
      });

    } catch (error) {
      // Handle error (e.g., show error message)
      console.error("Error resending OTP:", error);
    }
  };
  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };
  return (
    <div className="NV_Main_Container">
      <div className="NV_VrifyOtp_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="NV_Verification_Container">
        <p className="NV_Input_Heading_text">
          Confirm your Nominee Details
        </p>
        <span className="NV_Input_Sub_heading">
          Please enter the 6 digit code sent to your <br />
          Mobile Number
        </span>

        <div className="NV_Input_Filed_Box">
          <span className="Enter_NV_text">Enter 6 digit OTP</span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.bankAccountNumber ? classes.Error : ""
                }`}
              value={guardianVerification}
              maxLength={6}
              onChange={handleguardianVerificationChange}
            />

            <button
              className={classes.Cross_button}
              onClick={handleguardianVerificationClear}
            />
          </div>
        </div>

        <div className="Button_Container">
          <button
            className={`${classes.Resend_Otp_Btn} ${verificationError && verifyButtonClicked
                ? classes.Resend_Error
                : ""
              }`}
            style={{
              background: verifyButtonClicked ? "white" : "white",
            }}
            onClick={handleResendButtonClick}
          >
            Resend
          </button>

          <button className="Verify_Otp_Btn" onClick={HandleSubmit}>
            Verify OTP
          </button>
        </div>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      <ToastContainer />
    </div>
  );
};

export default NomineeVerification;
